import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import UISpinner from 'Components/UIComponents/UISpinner';
import WizardSignForm from 'Components/WizardSignForm';
import { useDocumentGuard } from 'Hooks/Document';
import { Document, DocumentTypes } from 'Interfaces/Document';
import { User } from 'Interfaces/User';
import { selectDocument, selectUser } from 'Utils/selectors';

const getSignersMinLength = (type: DocumentTypes) => {
  switch (type) {
    case DocumentTypes.TEMPLATE:
    case DocumentTypes.FORM_REQUEST:
    case DocumentTypes.ME: {
      return 1;
    }
    case DocumentTypes.OTHERS:
    case DocumentTypes.ME_AND_OTHER: {
      return 2;
    }
  }
};

type DocumentRouteParams = {
  documentId: Document['id'];
};

const Edit = () => {
  const params = useParams<DocumentRouteParams>();
  const { email }: User = useSelector(selectUser);
  const documentId = useMemo(() => params.documentId, [params]);

  const document = useSelector(state => selectDocument(state, { documentId }));
  const isCheckingDocument = useDocumentGuard({
    documentId,
  });

  const initialValues = useMemo(() => {
    if (document) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { fields, ...restDocument } = document;

      return {
        ...restDocument,
        signers:
          document.signers.length < getSignersMinLength(document.type)
            ? [...document.signers, { order: document.signers.length }]
            : document.signers,
        recipients: document.recipients,
      };
    }

    return {
      id: undefined,
      type: DocumentTypes.ME,
      signers: [
        {
          name: 'Me (Now)',
          email: email,
          order: -1,
          isPreparer: true,
        },
      ],
    };
  }, [document, email]);

  if (isCheckingDocument) {
    return <UISpinner wrapperClassName="spinner--main__wrapper" width={50} height={50} />;
  }

  return (
    <div className="dashboard__wrapper">
      <WizardSignForm initialValues={initialValues} isEditMode={true} />
    </div>
  );
};

export default Edit;
